import { defineStore } from 'pinia';
import { ref } from 'vue';
import { usePiniaRefStore } from '../../composables/usePiniaRefStore';

export const useCompanionUploadSettingsStore = defineStore(
  'companionUpload',
  () => {
    const compressImages = ref<boolean>(true);

    return {
      compressImages,
    };
  },
  {
    persist: {
      pick: ['compressImages'],
    },
  },
);

export const useCompanionUploadSettings = () => usePiniaRefStore(useCompanionUploadSettingsStore());
